var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('strong', [_vm._v("Existing auction types")])])]), _c('div', {
    staticClass: "card-body"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Existing auction types")]), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.dataSource,
      "pagination": {
        pageSize: 50
      },
      "row-key": function rowKey(record) {
        return record.id;
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn(record) {
        return _c('span', {}, [_c('a-space', {
          attrs: {
            "space": 16
          }
        }, [_c('a-popconfirm', {
          attrs: {
            "title": "Are you sure you want to swap status of this auction type?",
            "ok-text": "Yes",
            "cancel-text": "No"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.swapStatus(record.id);
            }
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-repeat font-size-15 align-middle text-gray-6",
          attrs: {
            "title": "Change status"
          }
        })])]), _c('a-popconfirm', {
          attrs: {
            "title": "Are you sure you want to delete this auction type?",
            "ok-text": "Yes",
            "cancel-text": "No"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.deleteAuctionType(record.id);
            }
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-trash font-size-15 align-middle text-gray-6",
          attrs: {
            "title": "Delete"
          }
        })])])], 1)], 1);
      }
    }, {
      key: "active",
      fn: function fn(text) {
        return _c('span', {}, [_c('a-tag', {
          attrs: {
            "color": text === 0 ? 'volcano' : 'green'
          }
        }, [_vm._v(" " + _vm._s(text === 0 ? 'INACTIVE' : 'ACTIVE') + " ")])], 1);
      }
    }])
  })], 1)])])]), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_c('strong', [_vm._v("Add new auction type")])])]), _c('div', {
    staticClass: "card-body"
  }, [_c('a-form-item', {
    attrs: {
      "label": "Auction type name"
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: _vm.name,
      callback: function callback($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c('a-form-item', [_c('a-button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": _vm.addAuctionType
    }
  }, [_c('i', {
    staticClass: "fe fe-plus-circle font-size-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": "Add participant"
    }
  }), _vm._v(" Add new auction type ")])], 1)], 1)])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }